var $f42eb083f6b372dc$exports = {};
$f42eb083f6b372dc$exports = {
    "endTime": `P\xe4\xe4ttymisaika`,
    "startTime": `Alkamisaika`,
    "time": `Aika`
};


export {$f42eb083f6b372dc$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
